import { normalizeNullValue } from '../address.utils';

export const commentField = {
    read(value) {
        return normalizeNullValue(value);
    },
};
